import React from "react";
import { Warehouse, Users, ShoppingCart, Truck } from "lucide-react";

interface DashboardCardProps {
  title: string;
  value: number;
  icon: "warehouse" | "users" | "shopping-cart" | "truck";
  color: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  icon,
  color,
}) => {
  const renderIcon = () => {
    switch (icon) {
      case "warehouse":
        return <Warehouse size={24} />;
      case "users":
        return <Users size={24} />;
      case "shopping-cart":
        return <ShoppingCart size={24} />;
      case "truck":
        return <Truck size={24} />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center mb-4">
        <div className={`p-3 rounded-full ${color} text-white mr-4`}>
          {renderIcon()}
        </div>
        <h3 className="text-lg font-semibold text-gray-700">{title}</h3>
      </div>
      <p className="text-3xl font-bold">{value?.toLocaleString()}</p>
    </div>
  );
};

export default DashboardCard;
